
import { capitalize, getErrorMessage, getLoginRedirectString, getPrepiBotBaseURL, useAxios } from "functions"
import { CSSProperties, useMemo, useState } from "react"
import Button from "../../1_atom/buttons/button"
import Tag from "../../1_atom/tag/tag"
import bg from '../../../public/img/docs/pricing/35.jpg'
import { toast } from "react-hot-toast"
import { iPriceTier, getPriceTiers } from "data"
import { useModal } from "../../../global/hooks"
import { iModal } from "typings"
import ClientOnly from "../../0_global/clientOnly"
import { useAuth } from "../../../context/authContext"
import { useRouter } from "next/router"
import { useStripe } from "@stripe/react-stripe-js"
import { loginRedirectURIState } from "../../../global/state/global"
import { useAtomValue } from "jotai"
import PoweredByStripe from '../../../public/stripe/stripe_white.svg';
import * as Sentry from "@sentry/nextjs";

interface BuyBoostProps {
  inSettings?: boolean
}

export default function BuyBoosts({ inSettings }: BuyBoostProps) {
  const [isAnnual, setIsAnnual] = useState(true)
  // const founderDiscountActive = Date.now() < 1680300000000
  // const activeDiscount = founderDiscountActive ? 0.5 : 1

  const tiers: iPriceTier[] = useMemo(() => {
    return getPriceTiers()
      .filter((tier) => {
        if (isAnnual && tier.intervalMonths !== 12) return false
        if(!isAnnual && tier.intervalMonths !== 3) return false
        return true
      })
      .sort((a, b) => (a.boosts > b.boosts ? 1 : -1))
  }, [isAnnual])

  const MonthlyToggle = () => {
    return (
      <div className={`align-self-center bg2 rounded border border-2 border-transparent ${inSettings ? "" : "mt-4"}`} style={{minWidth: 322, zIndex: 2}}>
        {/* relative mt-8 mb-8 bg2 rounded rounded-lg p-0.5 flex self-center */}
        <button
          className={`relative ${isAnnual ? "bg4 shadow-sm" : ""} rounded  py-2 w-1/2 text-sm font-medium text-color-normal whitespace-nowrap focus:outline-none sm:w-auto sm:px-8`}
          onClick={() => setIsAnnual(true)}
        >
          Yearly billing
        </button>
        <button
          className={`relative rounded ${isAnnual ? "" : "bg4 shadow-sm"} border-gray-200 py-2 w-1/2 text-sm font-medium text-color-normal whitespace-nowrap focus:outline-none sm:w-auto sm:px-8`}
          onClick={() => setIsAnnual(false)}
        >
          Quarterly billing
        </button>
      </div>
    )
  }

  const Discounted = () => {
    return (
      <div className="relative mx-auto mt-16 max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-md lg:max-w-4xl">
          <div className="flex flex-col gap-6 rounded p-8 ring-1 ring-gray-900/10 sm:p-10 lg:flex-row lg:items-center lg:gap-8">
            <div className="lg:min-w-0 lg:flex-1">
              <h3 className="text-lg font-semibold leading-8 tracking-tight text-primary">Discounted</h3>
              <div className="mt-2 text-base leading-7 text-gray-600">
                Get full access to all of standard license features for solo projects that make less than $20k gross
                revenue for <span className="font-semibold text-gray-900">$29</span>.
              </div>
            </div>
            <div>
              <a
                href="#"
                className="inline-block rounded bg-indigo-50 px-4 py-2.5 text-center text-sm font-semibold leading-5 text-indigo-700 hover:bg-indigo-100"
              >
                Buy discounted license <span aria-hidden="true">&rarr;</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    )
  }

  const Info = () => {
    if(inSettings) return <></>
    return (
      <div className="mx-auto max-w-7xl px-6 text-center lg:px-8  max-w-2xl lg:max-w-4xl">
        <h2 className="text-lg font-semibold leading-8 text-secondary">Pricing</h2>
        <p className="mt-2 text-4xl font-bold text-white">
          Unleash your teams potential!
        </p>
        <p className="mt-1 text-lg leading-8 weak-text">
          {/* Boost your team to new heights with Prepi team boosts to unlock powerful features! */}
          Boost your team to new heights with even more powerful features!
          {/* Lorem ipsum dolor sit, amet consectetur adipisicing elit. Velit numquam eligendi quos odit doloribus
          molestiae voluptatum. */}
        </p>
      </div>
    )
  }

  const Discounts = () => {
    const [triggerModal] = useModal()

    return <></>
    // if(founderDiscountActive === false) return <></>
    return (
      <div className="flex-col center-align mt2 mb2 rounded p2" style={{border: '3px solid grey', borderColor: "var(--secondary)"}}>
        <span className={`text-center weak-text text-xs`}>Founders deal</span>
        <h4 className={`text-center ${inSettings ? "" : "text-white"}`}>Get 50% off forever!</h4>
        <span className={`text-center weak-text`}>Offer lasts until March 31th 23.59 CET. <br />Applied automatically on checkout.</span>
        <Button
          color={inSettings ? "primary" : "white"}
          text="Learn more"
          addClass="align-self-center mt1"
          variant="soft"
          click={() => {
            const modal: iModal = {
              top: "Founders deal - February/ March 2023",
              middle: "Discount is applied on top of other discounts like yearly billing or bulk orders.\nOffer lasts until March 31st 23.59 CET\nDiscount stays active on that subscription as long as the subscription is active.\nSubscription can be cancelled at any time like all other subscriptions.",
              bottom: "I understand",
              options: {
                size: "medium"
              }
            }
            triggerModal(modal)
          }}
        />
      </div>
    )
  }

  const Tiers = () => {

    

    return (
      <div className="grid max-w-md mt-8 grid-cols-1 lg:max-w-4xl lg:grid-cols-2 gap2 w100">
        {tiers.map((tier) => (
          <div
            key={tier.priceID}
            className={`flex flex-col rounded shadow-xl ring-1 ring-black/10 p-8 sm:p-10 ${
              inSettings ? "bg4" : "bg-dark-subtle"
            }`}
            style={{height: 290}}
          >
            <h3
              className="text-lg font-semibold leading-8 tracking-tight text-secondary"
              id={tier.label}
            >
              {tier.labelShort}
            </h3>
            <div className="mt-4 flex items-baseline font-medium tracking-tight relative align-self-start">
              <h4 className={`weak-text`} style={{textDecoration: 'line-through'}}>{tier.discount > 0 ? `$${tier.priceMonthlyBeforeDiscount}` : <br />}</h4>
            </div>
            <div className="mt-4 flex items-baseline text-5xl font-medium tracking-tight relative align-self-start">
              <span className={inSettings ? "" : "text-white"}>${tier.priceMonthly}</span>
              <span className="text-lg font-semibold leading-8 tracking-normal weak-text">/mo</span>
              {(tier.discount > 0) && (
                <Tag
                  color={inSettings ? "primary": "white"}
                  text={`Save ${(tier.discount) * 100}%`}
                  addClass="mt2 tracking-normal"
                  style={{ top: -20, right: -45, position: "absolute" }}
                />
              )}
            </div>
            <GetBoostsButton tier={tier} />
          </div>
        ))}
      </div>
    )
  }

  const getContainerStyle = () => {
    let containerStyle: CSSProperties = {
      padding: inSettings ? 24 : 48
    }
    if(inSettings) return containerStyle
    return {
      ...containerStyle,
      backgroundImage: `url(${bg.src})`,
      backgroundSize: "cover",
      backgroundPositionY: "bottom"
    }
  }

  return (
    <div className={`w100 flex-col align-center bg1 rounded`} style={getContainerStyle()}>
      <Info />
      <Discounts />
      <MonthlyToggle />
      <Tiers />
      <div style={{color: inSettings ? 'var(--white-on-dark)' : 'white'}}>
        <PoweredByStripe width={150} className="noselect mt3" />
      </div>
    </div>
  )
}


const GetBoostsButton = ({ tier }: { tier: iPriceTier }) => {
  const loginRedirectURI = useAtomValue(loginRedirectURIState)
  const auth = useAuth()
  const router = useRouter()

  const axios = useAxios({ getBearerToken: auth.getFirebaseAuthToken, baseURL: getPrepiBotBaseURL() })
  const stripe = useStripe()

  const handleClickCheckout = async (lineItems: {price: string, quantity: number}[]) => {
    console.log("🚀 ~ file: buyBoosts.tsx:211 ~ handleClickCheckout ~ lineItems", lineItems)
    if (!lineItems) return toast.error("Please select a plan first.")
    if(!stripe) throw new Error("Stripe not found")

    const toastID = toast.loading("Redirecting")
    const res = await axios.post(
      `/checkout`,
      {
        line_items: lineItems
      },
      { validateStatus: () => true }
    )
    const sessionID = res.data.id
    if(res.status > 299){
      toast.error("Checkout redirect failed.", { id: toastID })
      console.error("Checkout redirect fail", res.data);
      Sentry.captureException(res);
      return
    }

    const { error } = await stripe.redirectToCheckout({
      sessionId: sessionID
    })

    if (error) {
      console.log(error)
    }
  }

  return (
    <ClientOnly>
      <Button
        text={`Get ${capitalize(tier.label)}`}
        size="mini"
        fullWidth
        addClass="mt-8"
        iconRight={{ icon: "link", fill: true }}
        click={() => {
          try {
            if(typeof auth.user !== "boolean" && !auth?.user?.email){
              router.push(getLoginRedirectString({ loginRedirectURI, withEmail: true }))
              return
            }
            if(!auth?.userData){
              router.push(getLoginRedirectString({ loginRedirectURI, withEmail: true }))
              return
            }
            if (handleClickCheckout && tier.priceID) {
              handleClickCheckout([{ price: tier.priceID, quantity: 1 }])
            }
          } catch (error) {
            toast.error(getErrorMessage(error))
          }
        }}
      />
    </ClientOnly>
  )
}